export const CART_NOTE_POINTS = (liquidCutOffTiming: string, othersCutOffTiming: string) => [
  `Please Note that the cut-off timings for transactions made through Axis Bank in liquid and overnight schemes is ${liquidCutOffTiming} and other schemes is ${othersCutOffTiming}. Transactions made post cut-off timings will be processed the next business day. The NAV applicability will vary as per the cut-off timings.`,

  `Please check the information entered before proceeding. Axis Bank will not be liable for any typographical error occurred while entering the details. Deal once entered & processed successfully can not be cancelled.`,

  `First systematic transaction will get executed immediately. The number of systematic transactions selected by you will be over and above this transaction, and will get executed in future as per the chosen schedule.`,
  `For cart-based transaction, a single OTP confirmation will be required, however there will be a separate debit in your bank account for each scheme.`,
];

export const DIFFERENT_INVESTMENTID_ERROR = (investmentId) => {
  return `Scheme/s already added to cart with Investment ID: 
    <span style="color:#97144d;font-weight:bold"> ${investmentId}</span>. Please use the same Investment ID to add more schemes to the cart.`;
};
export const DUPLICATE_FUND_ERROR = `The scheme with the same mode of investment (SIP/Lumpsum) is already added to cart. Please choose a different investment mode or add a different scheme.`;
export const VIEW_CART = 'View Cart';
export const MAX_NUMBER_OF_SCHEMES_ALREADY_ADDED = `Oops. At a time, 5 schemes can be added to the cart. This limitation is set to ease the transaction process with a single OTP. Kindly initiate a new cart or independent transaction if you wish to invest in more schemes.`;
export const SCHEME_NAME = 'Scheme Name';
export const FOLIO_NUMBER = 'Folio Number';
export const TRANS_TYPE = 'Trans Type';
export const AMOUNT = 'Amount';
export const REFERENCE = 'Reference Number';
export const ADD_TO_CART = 'Add To Cart';
export const START_A_SIP = 'Start a SIP';
export const EXPLORE_INTERNATIONAL_FUNDS = 'Explore International Funds';
export const MUTUAL_FUND_HOME = 'Mutual Fund Home';
export const TOTAL_INVESTMENT_AMOUNT = 'Total Investment Amount';
export const SIP = 'SIP';
export const LUMPSUM = 'Lumpsum';
export const SYSTEMATIC_INVESTMENT = 'Systematic Investment';
export const ONE_TIME_INVESTMENT = 'One Time Investment';
export const INVESTMENT_AMOUNT = 'Investment Amount';
export const ADD_MORE = 'Add More';
export const CONTINUE = 'Continue';
export const SIP_AMOUNT = 'SIP Amount';
export const LUMPSUM_AMOUNT = 'Lumpsum Amount';
export const REMOVE_CART_ITEM_PROMPT = 'Are you sure you want to remove the scheme from the cart?';
export const INVALID_CART_AMOUNT = 'Invalid Amount';
export const MINIMUM_INVESTMENT_AMOUNT_ERROR = (minAmount) => `Min ₹${minAmount}`;
export const EMPTY_CART_MESSAGE =
  "Empty carts don't look good. You can add up to 5 schemes to the cart and complete the investment with a single OTP.";
export const ADD_SCHEME_EMPTY_CART_CTA = 'Add scheme';
export const SUCCESSFUL = 'SUCCESSFUL!';
export const OK = 'OK';
export const TERMS_AND_CONDITION_ERROR_MESSAGE = 'Please agree to the Terms and Conditions to proceed further.';
export const INSUFFICIENT_BALANCE_MESSAGE =
  'Oops. Your account does not have adequate balance for this cart investment. Request you to please select another bank account or add funds to the account to proceed. Alternatively, you can change the investment amount.';

export const ENTER_OTP_LONG_TEXT_USER_DETAILS = (mobileNumber, emailId) => `${mobileNumber} & ${emailId.toLowerCase()}`;

export const REFERENCE_ID = (referenceId) => `MF${referenceId}`;

export const NFO_EXPIRY_MESSAGE = `Dear Customer, NFO/s present in your cart have expired based on respective cut-off timings. We suggest you to initiate a new cart-based transaction to proceed.`;
export const NFO_PARTIAL_EXPIRY_MESSAGE = `Dear Customer, some NFO/s present in your cart have expired based on respective cut-off timings and will not be considered upon submission of your transaction.`;

export const NFO_EXPIRY_STATUS = {
  ACTIVE: '700',
  NOT_EXPIRED: '701',
  PARTIALLY_EXPIRED: '702',
  EXPIRED: '703',
};
